module.exports = __webpack_public_path__ + "static/proactivness-beac6d6e8245d4af8022667d912e2d42.svg";